
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Ref, Prop, Watch } from "vue-property-decorator";
    import { VForm } from "@/vForm";
    import ColourSwatch from "@/vue/components/ColourSwatch.vue";
    import FileUpload from "@/vue/components/FileUpload.vue";
    import HtmlEditor from "@/vue/components/HtmlEditor.vue";
    import { Client } from "@/model/Client";
    import { DownloadOptions } from "@/model/pagePartOptions/DownloadOptions";
    import { Resource } from "@/model/Resource";
    
    @Component({ components: { ColourSwatch, FileUpload, HtmlEditor } })
    export default class DownloadPartEdit extends Vue {

        @Ref("editForm") private readonly editForm!: VForm;

        @Prop({ required: true })
        client!: Client;

        @Prop({ required: true })
        pagePartOptions!: DownloadOptions;

        colour(number: string|number): string {
            const grey = "#888";
            const field = `noteColour${number}`;
            if(!this.client) return grey;
            const value = String((this.client as any)[field]);
            return value || grey;
        }
        
        onUploaded(resource: Resource) {
            console.log("uploaded: ", resource);
        }

        validate(): boolean {
            return this.editForm.validate();
        }
    }
